export default [
  { title: "Payload", icon: "", link: "/docs/auth/http-request" },
];
